/**
 * 從 init api 取得的 key:'Target'物件，若其 value 為 1 就是一般的 Funliday 使用者，若為 2 就是 yahoo super APP 的使用者
 */
export const YAHOO_TARGET = 2;
